import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/authcontext';

const PublicRoute = () => {
    const authContext = useContext(AuthContext);

    if (!authContext) {
        throw new Error('PublicRoute must be used within an AuthProvider');
    }

    const { isAuthenticated, loading } = authContext;

    if (loading) {
        return (
            <div className="loader-container">
                <div className="spinner"></div>
                <p>Loading, please wait...</p>
            </div>
        );
    }

    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default PublicRoute;